<template lang="html">
  <div id="neighbourhood-page">
    <div class="row no-gutters">
      <neighbourhood-map class="col-xl-7 col-md-6 col-12"
      v-show="deviceMd || mobileMapOpen"
      :ready="ready"
      :poiList="poiList" :filteredPoiList="filteredPoiList"
      :mapData="mapData"
      :selectedPoiId="selectedPoiId"
      @setSelectedPoiId="setSelectedPoiId" />
      <neighbourhood-list class="col-xl-5 col-md-6 col-12"
      :poiList="filteredPoiList"
      :selectedPoiId="selectedPoiId"
      @setSelectedPoiId="setSelectedPoiId" />
    </div>
    <div v-if="!deviceMd"
    class="btn-toggle-map
    d-flex justify-content-center w-100">
      <button class="btn btn-action"
      @click="mobileMapOpen = !mobileMapOpen">
        {{ mobileMapToggleBtnLabel }}
      </button>
      <button class="btn btn-action ml-2"
      @click="showMobileFilters">
        Filter
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import { create } from 'vue-modal-dialogs';
import SingleSelectDialog from '@/components/Dialogs/SingleSelectDialog';
import NeighbourhoodMap from './NeighbourhoodMap';
import NeighbourhoodList from './NeighbourhoodList';

const singleSelectDialog = create(SingleSelectDialog, 'options', 'selectedIndex');

export default {
  name: 'neighbourhood-page',
  data() {
    return {
      mobileMapOpen: false,
      typeListIndex: 0
    };
  },
  computed: {
    ...mapState({
      ready: state => state.neighbourhood.ready,
      poiList: state => state.neighbourhood.poiList,
      mapData: state => state.neighbourhood.map,
      selectedPoiId: state => state.neighbourhood.selectedPoiId,
      filters: state => state.neighbourhood.filters
    }),
    ...mapGetters({
      filteredPoiList: 'neighbourhood/filteredPoiList',
      deviceMd: 'ui/deviceMd'
    }),
    mobileMapToggleBtnLabel() {
      if (this.mobileMapOpen) {
        return 'List';
      }
      return 'Map';
    }
  },
  methods: {
    ...mapMutations({
      setSelectedPoiId: 'neighbourhood/setSelectedPoiId',
      setPageReady: 'ui/setPageReady',
      setFilters: 'neighbourhood/setFilters'
    }),
    async showMobileFilters() {
      this.typeListIndex =
        await singleSelectDialog(
          ['All', ...this.filters.typeList.map(type => type.label)],
          this.typeListIndex
        );
      const mutableFilters = this.filters;
      mutableFilters.typeList.forEach((filter) => {
        filter.active = false;
      });
      if (this.typeListIndex > 0) {
        mutableFilters.typeList[this.typeListIndex - 1].active = true;
      }
      this.setFilters(mutableFilters);
      this.setSelectedPoiId('');
    }
  },
  mounted() {
    if (!this.deviceMd) {
      this.setPageReady(true);
    }
  },
  beforeDestroy() {
    this.setPageReady(false);
  },
  components: {
    'neighbourhood-map': NeighbourhoodMap,
    'neighbourhood-list': NeighbourhoodList
  }
};
</script>

<style lang="scss" scoped>
#neighbourhood-map {
  @media screen and (max-width: $breakpoint-medium) {
    position: absolute;
    top: 0;
    z-index: 100;
  }
}

.btn-toggle-map {
  position: fixed;
  bottom:  20px;
  z-index: 999;
}
</style>



// WEBPACK FOOTER //
// src/pages/NeighbourhoodPage/NeighbourhoodMap/NeighbourhoodPage.vue